module.exports = __webpack_public_path__ + "static/media/rowgatta_studio.56dcd1ce.svg";